import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';
import { TitleCard } from './title-card';
import { DescriptionCard } from './description-card';
import { Points } from '@styles';

export const ModelsLibrary = () => {
  const translations = useTranslations();
  const { locale } = useSelector((state) => state.settings);
  return (
    <View locale={locale === 'ru' ? 'ru' : 'en'}>
      <Content>
        <TitleCard text={translations.t('site.home.opportunities.models-library.title')} />
        <DescriptionCard text={translations.t('site.home.opportunities.models-library.description')} />
      </Content>
    </View>
  );
};

const View = styled.div`
  position: relative;
  padding: 16px 16px 47%;
  color: ${Colors.main_black};
  border-radius: 15.13px;
  background: ${(p) => `image-set(
        url('/images/mainpage/models-library-bg-mob-${p.locale}.webp') type('image/webp'),
        url('/images/mainpage/models-library-bg-mob-${p.locale}.png') type('image/png')
      )
      50% 100% / calc(100% - 32px) auto no-repeat,
    #e9f1fe`};

  @media ${Points.tablet_landscape} {
    padding: 30px 30px 35.75%;
    background: ${(p) => `image-set(
          url('/images/mainpage/models-library-bg-tab-${p.locale}.webp') type('image/webp'),
          url('/images/mainpage/models-library-bg-tab-${p.locale}.png') type('image/png')
        )
        50% 100% / calc(100% - 62px) auto no-repeat,
      #e9f1fe`};
  }

  @media ${Points.laptop_wide} {
    padding: 30px 30px 30%;
    padding: 40px;
    border-radius: 20px;
    background: ${(p) => `image-set(
          url('/images/mainpage/models-library-bg-lap-${p.locale}.webp') type('image/webp'),
          url('/images/mainpage/models-library-bg-lap-${p.locale}.png') type('image/png')
        )
        50% 100% / calc(100% - 80px) auto no-repeat,
      #e9f1fe`};
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 10px;

  @media ${Points.tablet_landscape} {
    gap: 15px;
  }
`;
